export default __webpack_public_path__ + "static/media/svg-2.06c5b413.svg";